import { useState } from 'react';
import { TrendingDown, Tag } from 'lucide-react';

const fmt = (a) => '$' + (a || 0).toLocaleString();

const VendorTag = ({ text, active, onClick }) => (
  <button onClick={onClick} className={`px-2 py-1 rounded-md text-xs font-medium transition-colors ${active ? 'bg-red-600 text-white' : 'bg-red-50 text-red-600'}`}>{text}</button>
);

const VendorItem = ({ name, cost }) => (
  <div className="flex justify-between text-xs text-gray-500"><span>{name}</span><span>{fmt(cost)}</span></div>
);

export function VendorExpenseBreakdown({ items }) {
  const [active, setActive] = useState([]);
  if (!items || items.length === 0) return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <h3 className="font-bold text-[#0A1628] flex items-center gap-2 mb-4"><TrendingDown className="w-4 h-4 text-red-500" /> Vendor Expenses</h3>
      <p className="text-sm text-gray-400 text-center py-6">No vendor costs. Add cost/vendor to products in Billing.</p>
    </div>
  );

  const allTags = [...new Set(items.flatMap(i => i.tags || []))];
  const filtered = active.length > 0 ? items.filter(i => (i.tags || []).some(t => active.includes(t))) : items;
  const total = filtered.reduce((s, i) => s + (i.total || 0), 0);
  const toggle = (t) => setActive(p => p.includes(t) ? p.filter(x => x !== t) : [...p, t]);

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-bold text-[#0A1628] flex items-center gap-2"><TrendingDown className="w-4 h-4 text-red-500" /> Vendor Expenses</h3>
        <span className="text-sm font-bold text-red-500">{fmt(total)}</span>
      </div>
      {allTags.length > 0 && (
        <div className="flex items-center gap-1.5 flex-wrap mb-4">
          <Tag className="w-3 h-3 text-gray-400" />
          {allTags.map(t => <VendorTag key={t} text={t} active={active.includes(t)} onClick={() => toggle(t)} />)}
          {active.length > 0 && <button onClick={() => setActive([])} className="text-[10px] text-red-500 hover:underline ml-1">Clear</button>}
        </div>
      )}
      <div className="divide-y">
        {filtered.map((v, i) => (
          <div key={i} className="py-3">
            <div className="flex items-center justify-between mb-1">
              <p className="font-semibold text-sm text-[#0A1628]">{v.vendor}</p>
              <p className="font-bold text-red-600 text-sm">{fmt(v.total)}</p>
            </div>
            <div className="ml-4 mt-1 space-y-0.5">
              {(v.items || []).map((it, j) => <VendorItem key={j} name={it.name} cost={it.cost} />)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
